import { api } from "api";
import Swal from "sweetalert2";
import { push, goBack } from "react-router-redux";
import { ToastStore } from "react-toasts";
import { handleActions } from "redux-actions";
import { initialize as initializeForm } from "redux-form";

// ------------------------------------
// Constants
// ------------------------------------
export const DATA = "DESTINO_SALIDA_PRODUCTOS_DATA";
export const PAGE = "DESTINO_SALIDA_PRODUCTOS_PAGE";
export const BUSCADOR = "DESTINO_SALIDA_PRODUCTOS_BUSCADOR";
export const SORT = "DESTINO_SALIDA_PRODUCTOS_SORT";
export const LOADER = "DESTINO_SALIDA_PRODUCTOS_LOADER";
export const DESTINO = "DESTINO_SALIDA_PRODUCTOS_DESTINO";

const endpoint = "destino_salida_producto";

// ------------------------------------
// Actions
// ------------------------------------
export const listar = (page = 1) => (dispatch, getStore) => {
    dispatch(setLoader(true));
    const store = getStore();
    const { ordering, search } = store.destino_salida_producto;

    api.get(endpoint, { page, ordering, search })
        .catch((err) => {})
        .then((data) => {
            if (data) {
                dispatch(setData(data));
            }
            dispatch(setPage(page));
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

export const buscar = (search) => (dispatch) => {
    dispatch(setBuscador(search));
    dispatch(listar());
};

export const sortChange = (sortName, sortOrder) => (dispatch, getStore) => {
    if (sortOrder === "asc") {
        dispatch(setSort(sortName));
    } else {
        dispatch(setSort(`-${sortName}`));
    }
    const store = getStore();
    const page = store.destino_salida_producto.page;
    dispatch(listar(page));
};

export const crear = () => (dispatch, getStore) => {
    dispatch(setLoader(true));
    const store = getStore();
    const data = store.form.DestinoSalidaProductoCrear.values;
    api.post(endpoint, data)
        .catch((err) => {
            Swal(
                "ERROR",
                "Ha ocurrido un error, verifique los datos y vuelva a intentar.",
                "error"
            );
        })
        .then((resp) => {
            if (resp) {
                ToastStore.success("Datos almacenados correctamente");
                dispatch(goBack());
            }
            dispatch(setLoader(false));
        });
};

export const leer = (id) => (dispatch, getStore) => {
    dispatch(setLoader(true));
    api.get(`${endpoint}/${id}`)
        .catch((err) => {
            Swal("ERROR", "Ha ocurrido un error.", "error");
        })
        .then((resp) => {
            if (resp) {
                dispatch(setDestino(resp));
                dispatch(initializeForm("DestinoSalidaProductoCrear", resp));
            }
            dispatch(setLoader(false));
        });
};

export const editar = () => (dispatch, getStore) => {
    const store = getStore();
    const data = store.form.DestinoSalidaProductoCrear.values;
    dispatch(setLoader(true));
    api.put(`${endpoint}/${data.id}`, data)
        .catch((err) => {
            Swal(
                "ERROR",
                "Ha ocurrido un error, verifique los datos y vuelva a intentar.",
                "error"
            );
        })
        .then((resp) => {
            if (resp) {
                ToastStore.success("Datos almacenados correctamente");
                dispatch(push("/configuracion/destinos_salida_de_productos"));
            }
            dispatch(setLoader(false));
        });
};

export const eliminar = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.eliminar(`${endpoint}/${id}`)
        .catch((error) => {
            Swal("ERROR", "Ha ocurrido un error, intente más tarde.", "error");
        })
        .then((data) => {
            if (data) {
                ToastStore.success("Registro eliminado.");
                dispatch(listar());
            }
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

// ------------------------------------
// PureActions
// ------------------------------------

export const setData = (data) => ({
    type: DATA,
    data,
});
export const setPage = (page) => ({
    type: PAGE,
    page,
});
export const setBuscador = (search) => ({
    type: BUSCADOR,
    search,
});
export const setSort = (ordering) => ({
    type: SORT,
    ordering,
});
export const setLoader = (loader) => ({
    type: LOADER,
    loader,
});
export const setDestino = (destino) => ({
    type: DESTINO,
    destino,
});

export const actions = {
    crear,
    listar,
    buscar,
    sortChange,
    leer,
    editar,
    eliminar,
};

// ------------------------------------
// Reducers
// ------------------------------------
export const reducers = {
    [DATA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [PAGE]: (state, { page }) => {
        return {
            ...state,
            page,
        };
    },
    [BUSCADOR]: (state, { search }) => {
        return {
            ...state,
            search,
        };
    },
    [SORT]: (state, { ordering }) => {
        return {
            ...state,
            ordering,
        };
    },
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [DESTINO]: (state, { destino }) => {
        return {
            ...state,
            destino,
        };
    },
};

// ------------------------------------
// InitialState
// ------------------------------------
export const initialState = {
    data: {},
    page: 1,
    search: "",
    ordering: "",
    loader: false,
    destino: {},
};

export default handleActions(reducers, initialState);
